var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from 'styled-components';
var ScWrapper = styled.div.withConfig({ displayName: "ScWrapper", componentId: "sc-1leki22" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  background: ", ";\n  border-radius: 8px;\n"], ["\n  display: inline-flex;\n  background: ", ";\n  border-radius: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue95;
});
var ScTab = styled.button.withConfig({ displayName: "ScTab", componentId: "sc-x9eyc2" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: none;\n  background: ", ";\n  color: ", ";\n  padding: 10px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 24px;\n"], ["\n  border: none;\n  background: ", ";\n  color: ", ";\n  padding: 10px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 24px;\n"])), function (_a) {
    var theme = _a.theme, $active = _a.$active;
    return $active ? theme.colors.blue60 : 'transparent';
}, function (_a) {
    var theme = _a.theme, $active = _a.$active;
    return $active ? theme.colors.white : theme.colors.blue50;
});
var Tabs = function (_a) {
    var tabs = _a.tabs, onClick = _a.onClick, initActiveTab = _a.initActiveTab;
    var _b = React.useState(initActiveTab), activeTab = _b[0], setActiveTab = _b[1];
    var onTabClick = React.useCallback(function (tabName) {
        setActiveTab(tabName);
        onClick(tabName);
    }, [onClick]);
    return (_jsx(ScWrapper, { children: tabs.map(function (tab) { return (_jsx(ScTab, __assign({ onClick: function () { return onTabClick(tab); }, "$active": (activeTab === null || activeTab === void 0 ? void 0 : activeTab.id) === tab.id }, { children: tab.name + " " + (tab.counter !== undefined ? "(" + tab.counter + ")" : '') }), tab.id)); }) }, void 0));
};
export default Tabs;
var templateObject_1, templateObject_2;
